module.exports = __webpack_public_path__ + "media/img/services/services-card-img1-b965be277b3fe3e4a1ddacf8a39b4503.svg";